import React, {
    PureComponent
  }                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
  }                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import styles                 from './style'
import moment from 'moment';

class AddEvent extends PureComponent{
    static PropTypes = {
        actions: PropTypes.shape({
            enterPage: PropTypes.func,
            leavePage: PropTypes.func,
        })
    };

    constructor(props){
        super(props);
        this.state = {
            venues: [],
            game_types: [],
            age_categories: [],
            event_details: {
                venue: '',
                name: '',
                game_type: '',
                age_categories: '',
                start_date: '',
                registration_end: '',
                banner: '',
                description: '',
                registration_amount: '',
            },
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFile = this.handleFile.bind(this);
    }

    componentDidMount() {
        this.getEventDetails();
        console.log(this.state);
    }

    getEventDetails() {
        const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_event/`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            this.setState(
            { venues: data.venues,
              game_types: data.game_types,
              age_categories: data.age_categories
            });
           })
          .catch(error => error);
    }

    postaddEvent(data, props) {
        if(!data.venue){data.venue=this.state.venues[0].id}
        if(!data.game_type){data.game_type=this.state.game_types[0].pk}
        if(!data.age_categories){data.age_categories=this.state.age_categories[0].id}
        console.log(data);
        const url = `${getLocationOrigin()}/eagleeye/add_event/`;
        const options = {...defaultOptions};
        var formData = new FormData();
        for(var name in data) {
          formData.append(name, data[name]);
        }
        for(var start_date in data){
            formData.append(start_date, data[start_date]);
        }
        for(var registration_end in data){
            formData.append(registration_end, data[registration_end]);
        }
        options['method'] = 'post';
        options['body'] = formData;
        console.log('Going to fetch');
        return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then(function(response){                      // first then()
                alert(response.message);
                props.history.goBack();
                })
            .catch(error => {
                console.log(error);
                alert(error.message);
            });
      }
   

    handleChange(event) {
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.event_details);
        new_value[name] = event.target.value
        this.setState({event_details: new_value});
    }

    handleStartDateChange(event){
        const start_date = event.target.name
        var new_value = Object.assign({}, this.state.event_details);
        new_value[start_date] = event.target.value
        this.setState({event_details: new_value});
    }
    handleEndDateChange(event){
        const registration_end = event.target.name;
        var new_value = Object.assign({}, this.state.event_details);
        new_value[registration_end] = event.target.value
        this.setState({event_details: new_value})

    }
    handleFile(selectorFiles: FileList){
        var new_value =  Object.assign({}, this.state.event_details);
        console.log('Fileeeee');
        console.log(selectorFiles);
        new_value['banner'] = selectorFiles[0]
        this.setState({event_details: new_value});
      }

    handleSubmit(){
        event.preventDefault();
        console.log('Event_Details');
        console.log(this.state.event_details);
        this.postaddEvent(this.state.event_details, this.props);
        console.log('post');
        console.log(this.state);
    }
    render(){
        return(
        <div style={styles.container}>
            <div className="row col-md-8 table-bordered" style={styles.table}>
                <div style={styles.main_header} >
                    <h3 style={{textAlign:'center'}}>Add Event</h3>
                </div>
                <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Event Name
                    </div>
                    <input type="text" style={styles.input} name="name" className="required"
                        value={this.state.value} onChange={this.handleChange}/>    
                </div>
                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Venue
                    </div>
                    <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.value}
                        onChange={this.handleChange}>
                        <option key={-1} value={""} defaultValue={true}> {"-----------------"}</option>
                        {
                        this.state.venues.map((venue, index) => (
                        <option key={venue.id} value={venue.id}>{venue.name}</option>
                        ))
                        }
                    </select>
                </div>
                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Game Type
                    </div>
                    <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.value}
                        onChange={this.handleChange}>
                        <option key={-1} value={""} defaultValue={true}> {"-----------------"}</option>
                        {
                        this.state.game_types.map((game_type, index) => (
                        <option key={game_type.pk} value={game_type.pk}>{game_type.game +'-'+ game_type.name}</option>
                        ))
                        }
                    </select>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Age Category
                    </div>
                    <select name="age_categories" className="col-md-6" style={styles.item_body} value={this.state.value}
                        onChange={this.handleChange}>
                        <option key={-1} value={""} defaultValue={true}> {"-----------------"}</option>
                        {
                        this.state.age_categories.map((age_category, index) => (
                        <option key={age_category.id} value={age_category.id}>{age_category.name}</option>
                        ))
                        }
                    </select>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                     Banner
                    </div>
                    <input type="file" style={styles.input} style={{float:'left'}} name="banner" onChange={ (e) => this.handleFile(e.target.files) }/>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                     Start Date(DD/MM/YYYY)
                    </div>
                    <input type='text' style={styles.input} name="start_date" value={this.state.value} onChange={this.handleStartDateChange}/>
                    
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                     Registration End Date(DD/MM/YYYY)
                    </div>
                    <input type='text' style={styles.input} name="registration_end" value={this.state.value} onChange={this.handleEndDateChange}/>
                    
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Description
                    </div>
                    <textarea rows="4" cols="33" style={styles.input} id="description" name="description" placeholder="Description"
                        onChange={this.handleChange}>
                        {this.state.event_details.description}
                    </textarea>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Registration Amount
                    </div>
                    <input type="number" style={styles.input} name="registration_amount" className="required"
                        value={this.state.value} onChange={this.handleChange}/>
                </div>

                <div style={styles.button_submit} className="col-md-12">
                    <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                        color:'#ffffff'}}/>
                </div>
                
                </form>
            </div>
        </div>    
        );
    }
}

export default AddEvent;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addEvent/index.js